export const STARTING_MODELS = [
  { value: 'Property', label: 'Property', description: 'Cemetery property records' },
  { value: 'Invoice', label: 'Invoice', description: 'Customer invoice records' },
  { value: 'Marker', label: 'Marker', description: 'Marker and monument records' },
  { value: 'Case', label: 'Case', description: 'Case records' },
  { value: 'WorkOrder', label: 'Work Order', description: 'Service and maintenance records' },
  { value: 'Customer', label: 'Customer', description: '' },
  { value: 'Contact', label: 'Contact', description: '' }
];

export const STARTING_MODEL_CLASS_MAP = {
  Property: 'App\\Models\\Grave',
  Invoice: 'App\\Models\\AR\\Invoice',
  Marker: 'App\\Models\\Marker',
  Case: 'App\\Models\\FuneralCase',
  WorkOrder: 'App\\Models\\WorkOrder',
  Customer: 'App\\Models\\Account',
  Contact: 'App\\Models\\Contact'
};

const STARTING_MODEL_BY_VALUE = new Map(STARTING_MODELS.map((model) => [model.value, model]));

export function normalizeStartingModels(models = []) {
  if (!Array.isArray(models)) return [];

  return models
    .map((model) => {
      if (!model || typeof model.name !== 'string') return null;
      const fallback = STARTING_MODEL_BY_VALUE.get(model.name);
      if (!fallback) return null;

      return {
        value: model.name,
        label: model.label || fallback.label,
        description: model.description || fallback.description,
        className: model.class || STARTING_MODEL_CLASS_MAP[model.name] || `App\\Models\\${model.name}`,
        postType: model.post_type
      };
    })
    .filter(Boolean);
}

export function getStartingModelLabel(value) {
  return STARTING_MODEL_BY_VALUE.get(value)?.label || value || 'Unknown record type';
}

export function getStartingModelClass(value) {
  return STARTING_MODEL_CLASS_MAP[value] || `App\\Models\\${value}`;
}
